var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-arrow-right",attrs:{"aria-hidden":"true","tabindex":"-1","role":"presentation","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#000000","d":"M8.5,5.015L10.117,3.5L23.5,16L10.117,28.5L8.5,26.991L20.258,16L8.5,5.015z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }